import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, PropType, watch, onMounted } from 'vue';
import VirtualList from 'vue3-virtual-scroll-list';
import EntryLine from './EntryLine.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'LogViewer',
  props: { entries: { type: Array as PropType<Array<any>> } },
  setup(__props) {

const props = __props;
const vlst = ref(null);

onMounted(() => {
  watch(() => props.entries, (currentVal, oldVal) => {
    console.log(vlst.value);
    (vlst.value as any).scrollToBottom();
    console.log(JSON.stringify(currentVal?.length));
  }, { deep: true })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VirtualList), {
      style: {"height":"100%"},
      class: "overflow-y-auto bg-nosferatu-700 pl-2",
      "data-key": 'id',
      keeps: 120,
      "data-sources": __props.entries,
      "data-component": EntryLine,
      ref_key: "vlst",
      ref: vlst
    }, null, 8 /* PROPS */, ["data-sources"]),
    _createCommentVNode("div class=\"flex justify-end\">De Marque Inc.</div")
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})